var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaddockNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 120 145",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 10,10 h 100 v 100 h -25 l -25,25 l -25,-25 h -25 Z",
    id: "foreground",
    style: {
      fill: "#fff",
      stroke: "#45a",
      strokeWidth: 5
    }
  }), /*#__PURE__*/React.createElement("svg", _extends({
    x: 25,
    y: 25,
    width: 70,
    height: 70,
    viewBox: "0 0 34 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.93114 0L6.63804 1.7069L8.34494 0L10.0518 1.7069L9.66028 2.09845H18.9688L18.5773 1.7069L20.2842 1.15164e-06L21.9911 1.7069L23.6979 1.02277e-06L25.4048 1.7069L25.0133 2.09845H33.9173V4.41475H24.6989L25.4048 5.12069L23.6979 6.82759L21.9911 5.12069L20.2842 6.82759L18.5773 5.12069L19.2832 4.41475H9.34589L10.0518 5.12069L8.34494 6.82759L6.63804 5.12069L4.93114 6.82759L3.22425 5.12069L3.93019 4.41475H0V2.09845H3.6158L3.22425 1.7069L4.93114 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 21.5188C30.7954 19.8313 16.7825 12.5915 10.3433 11.5685C6.55609 11.0088 2.60835 10.561 0 10.7846V22.3661H34V21.5188Z",
    fill: "#0a0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1422 12.9515C24.6287 15.2285 31.2865 18.4911 34 19.8416V11.7773C30.6634 12.2185 23.345 13.1009 20.764 13.1009C20.4016 13.1009 19.8459 13.0455 19.1422 12.9515Z",
    fill: "#060"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddockNormal);
export default __webpack_public_path__ + "static/media/PaddockNormal.3a4e131d12cfb4754d5041b4189326a0.svg";
export { ForwardRef as ReactComponent };